var map = {
	"./ion-action-sheet.entry.js": [
		63836,
		3836
	],
	"./ion-alert.entry.js": [
		1058,
		1058
	],
	"./ion-app_8.entry.js": [
		9252,
		9252
	],
	"./ion-avatar_3.entry.js": [
		23141,
		3141
	],
	"./ion-back-button.entry.js": [
		92067,
		2067
	],
	"./ion-backdrop.entry.js": [
		48877,
		8877
	],
	"./ion-button_2.entry.js": [
		84472,
		4472
	],
	"./ion-card_5.entry.js": [
		32683,
		2683
	],
	"./ion-checkbox.entry.js": [
		26379,
		6379
	],
	"./ion-chip.entry.js": [
		99198,
		9198
	],
	"./ion-col_3.entry.js": [
		18844,
		8844
	],
	"./ion-datetime_3.entry.js": [
		97754,
		7754
	],
	"./ion-fab_3.entry.js": [
		79827,
		9827
	],
	"./ion-img.entry.js": [
		93171,
		3171
	],
	"./ion-infinite-scroll_2.entry.js": [
		26148,
		6148
	],
	"./ion-input.entry.js": [
		15729,
		5729
	],
	"./ion-item-option_3.entry.js": [
		36100,
		6100
	],
	"./ion-item_8.entry.js": [
		20597,
		597
	],
	"./ion-loading.entry.js": [
		38813,
		8813
	],
	"./ion-menu_3.entry.js": [
		902,
		902
	],
	"./ion-modal.entry.js": [
		86181,
		6181
	],
	"./ion-nav_2.entry.js": [
		89606,
		9606
	],
	"./ion-popover.entry.js": [
		71033,
		1033
	],
	"./ion-progress-bar.entry.js": [
		75884,
		5884
	],
	"./ion-radio_2.entry.js": [
		22060,
		2060
	],
	"./ion-range.entry.js": [
		57130,
		7130
	],
	"./ion-refresher_2.entry.js": [
		73750,
		3750
	],
	"./ion-reorder_2.entry.js": [
		45062,
		5062
	],
	"./ion-ripple-effect.entry.js": [
		80940,
		940
	],
	"./ion-route_4.entry.js": [
		27372,
		7372
	],
	"./ion-searchbar.entry.js": [
		91060,
		1060
	],
	"./ion-segment_2.entry.js": [
		16155,
		6155
	],
	"./ion-select_3.entry.js": [
		34221,
		4221
	],
	"./ion-slide_2.entry.js": [
		60101,
		101
	],
	"./ion-spinner.entry.js": [
		29317,
		9317
	],
	"./ion-split-pane.entry.js": [
		9853,
		9853
	],
	"./ion-tab-bar_2.entry.js": [
		82598,
		2598
	],
	"./ion-tab_2.entry.js": [
		78193,
		8193
	],
	"./ion-text.entry.js": [
		19420,
		9420
	],
	"./ion-textarea.entry.js": [
		265,
		265
	],
	"./ion-toast.entry.js": [
		12522,
		8036
	],
	"./ion-toggle.entry.js": [
		51394,
		1394
	],
	"./ion-virtual-scroll.entry.js": [
		74229,
		4229
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 379;
module.exports = webpackAsyncContext;